export default __webpack_public_path__ + "static/media/mandala_wolf.dc950fe0.jpg";